import { useEffect, useRef, useState } from "react"

export function useClampedOverflow(content: unknown, isExpanded: boolean) {
  const clampedRef = useRef<HTMLDivElement>(null)
  const [overflowsClamp, setOverflowsClamp] = useState(false)

  useEffect(() => {
    const element = clampedRef.current
    if (!element || isExpanded) return
    const measure = () => setOverflowsClamp(element.scrollHeight > element.clientHeight + 1)
    measure()
    if (typeof ResizeObserver === "undefined") return
    const observer = new ResizeObserver(measure)
    observer.observe(element)
    return () => observer.disconnect()
  }, [content, isExpanded])

  return { clampedRef, canExpand: overflowsClamp || isExpanded }
}
